import { createSlice } from "@reduxjs/toolkit";

const getInitialTheme = () => {
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme === "dark") return true;
  if (savedTheme === "light") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
};

const initialState = {
  darkmode: getInitialTheme(),
};

// Apply initial dark mode class to html element
if (initialState.darkmode) {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleDarkmode: (state) => {
      state.darkmode = !state.darkmode;
      localStorage.setItem("theme", state.darkmode ? "dark" : "light");
      if (state.darkmode) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
    setDarkmode: (state, action) => {
      state.darkmode = action.payload;
      localStorage.setItem("theme", action.payload ? "dark" : "light");
      if (action.payload) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
  },
});

export const { toggleDarkmode, setDarkmode } = themeSlice.actions;
export default themeSlice.reducer;
